import { Spinner } from '@facephi/ui-react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { useFacialAuth } from '../providers';
import { useAuth } from '../providers/AuthProvider';
import { RoutesName, userInfoCompletedState } from '../states';

type IProps = {
  facial?: boolean;
  vocal?: boolean;
  acceptedTerms?: boolean;
  completedUserInfo?: boolean;
};

export const ProtectedRoute = ({
  facial,
  acceptedTerms,
  completedUserInfo,
}: IProps) => {
  const { logged, loadingTerms, terms } = useAuth();
  const { facialValidated } = useFacialAuth();
  const location = useLocation();
  const isTermsPage = location.pathname === RoutesName.terms;
  const isUserInfoPage = location.pathname === RoutesName.userInfo;
  const userInfoCompleted = useRecoilValue(userInfoCompletedState);
  const hasTerms = !acceptedTerms || terms;
  const hasBiometry = !facial || facialValidated;
  const hasCompletedInfo = !completedUserInfo || userInfoCompleted;

  if ((terms && isTermsPage) || (userInfoCompleted && isUserInfoPage))
    return <Navigate to={RoutesName.home} />;

  return (
    <>
      {logged ? (
        loadingTerms ? (
          <Spinner />
        ) : !hasTerms ? (
          <Navigate to={RoutesName.terms} />
        ) : !hasCompletedInfo ? (
          <Navigate to={RoutesName.userInfo} />
        ) : !hasBiometry ? (
          <Navigate to={RoutesName.widget} />
        ) : (
          <Outlet />
        )
      ) : (
        <Navigate to={RoutesName.login} />
      )}
    </>
  );
};
